import { render, staticRenderFns } from "./PencilIcon.vue?vue&type=template&id=bf7523b4&scoped=true&"
import script from "./PencilIcon.vue?vue&type=script&lang=js&"
export * from "./PencilIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7523b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf7523b4')) {
      api.createRecord('bf7523b4', component.options)
    } else {
      api.reload('bf7523b4', component.options)
    }
    module.hot.accept("./PencilIcon.vue?vue&type=template&id=bf7523b4&scoped=true&", function () {
      api.rerender('bf7523b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/icons/PencilIcon.vue"
export default component.exports